import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Funcionalidad } from '../../_models/funcionalidad';

@Component( {
  selector: 'app-vinculacion-tercero',
  templateUrl: 'vinculacion-tercero.component.html'
} )

export class VinculacionTerceroComponent implements OnInit {
  /** Listas */
  lisVinculacion: ListaItem[] = [];

  columnas: any[];
  carInformacionInicial = true;
  menu: Funcionalidad = new Funcionalidad();
  carTabla = true;

  constructor(
    private conServicio: ConfirmationService,
    private route: ActivatedRoute,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private serLista: ListaService
  ) {
  }

  ngOnInit() {
    this.serLista.getMasterDetails( 'ListasTiposVinculaciones' ).subscribe( vinculacion => {
      const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/preguntas' );
      if ( mn ) {
        this.menu = mn;
      }
      this.columnas = [
        { field: 'tipoVinculacion', header: this.navServicio.buscarMensaje( 'VINCULACIONTERCERO.LBL_TIPOVINCULACION' ), sort: false },
        { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false },
      ];

      this.lisVinculacion = vinculacion.filter( x => x.codigo !== 'NOFIR' );

      this.carTabla = false;
      this.carInformacionInicial = false;
    } );

  }

  redirigir( item: ListaItem ) {
    this.router.navigate( [ 'apl/vinculacion-tercero/configurar-vinculacion/' + item.idLista ] );
  }

}
